import { useNavigate } from "react-router-dom";
import { FaLeftLong } from "react-icons/fa6";

const BackButton = ({ navigateTo }) => {
    const navigate = useNavigate();
    return (
        <button
            className="back-button"
            onClick={() => navigate(navigateTo)}>
                <FaLeftLong /> &nbsp; Back
        </button>
    )
}

export default BackButton;